import pphoc from "../../../assets/img/pp_hoc_v2.png"

const StudyMethod = () => {
    return (
        <div className=" py-[80px] bg-[#f3f3f3]">
            <h1 className="mb-[30px] text-[36px] text-center uppercase font-bold text-[#4195f2]">Phương pháp học Anh ngữ<br/>
            hiệu quả và toàn diện</h1>
            <img src={pphoc} className="w-[960px] m-auto h-full" alt="method"/>
        </div>
    )
}

export default StudyMethod